/* VILLIN — header logo motion · concept F · THE WORD WRITES OUT AND BACK IN (Jason 2026-10-04:
 * "how it writes VILLIN, and then it comes away and comes back… so the word comes in and out").
 *
 * - First page of the visit: VILLIN writes itself in — V, I, L, L, I, N, one letter at a time (~0.9s),
 *   at exactly the logo's normal size and position (nothing scales or moves).
 * - Every time the header changes state (the bar arrives as you scroll down, or you go back to
 *   the top), the word is cut away along the slant and written straight back in. It never stays
 *   hidden — the word is always on screen at rest. ~1s, the same length as Represent's move.
 * Blade engine from concept D: one clip-path polygon parallel to the letter strokes (V first,
 * N last), tweened in JS (no reliance on iOS clip-path interpolation), only while moving.
 * Touches only the two existing logo <img>s, so the theme's white/black swap is untouched.
 * prefers-reduced-motion: reduce -> nothing runs. */
(function () {
  'use strict';
  if (window.__villinLogoMotion) return;
  window.__villinLogoMotion = true;

  var SEL = '.header__logo-image';
  var SLANT = 17.78, IN = 12, OUT = 108, DRIFT = 0;   // measured on the live logo (see concept D); no drift = the mark never moves or resizes
  // Where each letter sits along the slant (blade position at the top edge, % of logo width), measured from the live
  // logo PNG (533x140) alpha: V, I, L, L, I, N (the ® is written with the N).
  var LETTERS = [[13.26, 32.77], [34.40, 42.10], [44.88, 57.13], [58.73, 70.98], [72.57, 80.27], [83.06, 106.26]];
  var LETTER_MS = 115, LETTER_GAP = 40;              // each letter is written in turn, then a breath before the next
  var OUT_MS = 340, GAP_MS = 90;
  var THRESH = 120;                                   // px: "at the top" vs "scrolled"

  function bezier(x1, y1, x2, y2) {
    var cx = 3 * x1, bx = 3 * (x2 - x1) - cx, ax = 1 - cx - bx, cy = 3 * y1, by = 3 * (y2 - y1) - cy, ay = 1 - cy - by;
    return function (x) {
      if (x <= 0) return 0; if (x >= 1) return 1;
      var lo = 0, hi = 1, t = x;
      for (var i = 0; i < 22; i++) { var v = ((ax * t + bx) * t + cx) * t; if (v < x) lo = t; else hi = t; t = (lo + hi) / 2; }
      return ((ay * t + by) * t + cy) * t;
    };
  }
  var easeOut = bezier(0.7, 0, 0.84, 0);    // cut: accelerates away
  var easeIn = bezier(0.16, 1, 0.3, 1);     // write: arrives fast, settles long

  var imgs = null;
  function logos() { if (!imgs || !imgs.length || !imgs[0].isConnected) imgs = document.querySelectorAll(SEL); return imgs; }
  var cur = { l: IN, r: OUT, d: 0 }, raf = 0, busy = false, gen = 0;   // gen: newest write wins (no intro/rewrite tug-of-war)
  function paint() {
    var list = logos(), clip = '', tr = '';
    if (!(cur.l <= IN && cur.r >= OUT && cur.d === 0)) {
      clip = 'polygon(' + cur.l.toFixed(2) + '% 0%,' + cur.r.toFixed(2) + '% 0%,' + (cur.r - SLANT).toFixed(2) + '% 100%,' + (cur.l - SLANT).toFixed(2) + '% 100%)';
      tr = cur.d ? 'translate3d(' + cur.d.toFixed(2) + '%,0,0)' : '';
    }
    for (var i = 0; i < list.length; i++) { var s = list[i].style; s.webkitClipPath = clip; s.clipPath = clip; s.transform = tr; }
  }
  function tween(to, ms, ease, done) {
    if (raf) cancelAnimationFrame(raf);
    var from = { l: cur.l, r: cur.r, d: cur.d }, t0 = 0;
    function step(now) {
      if (!t0) t0 = now;
      var k = ease(Math.min(1, (now - t0) / ms));
      cur.l = from.l + (to.l - from.l) * k; cur.r = from.r + (to.r - from.r) * k; cur.d = from.d + (to.d - from.d) * k;
      var end = (now - t0) >= ms;
      if (end) { cur.l = to.l; cur.r = to.r; cur.d = to.d; raf = 0; }
      paint();
      if (!end) raf = requestAnimationFrame(step); else if (done) done();
    }
    raf = requestAnimationFrame(step);
  }
  var easeStroke = bezier(0.45, 0, 0.25, 1);  // one letter: pen speeds up, then lifts gently
  function writeIn(ms, done) {             // V, I, L, L, I, N — one letter at a time, at the logo's normal size
    var my = ++gen;
    cur.l = IN; cur.r = LETTERS[0][0] - 0.6; cur.d = 0; paint();
    document.documentElement.classList.remove('vln-logo-intro');   // head loader pre-hid the logo so the word never flashes before it is written
    var k = 0;
    (function next() {
      if (my !== gen) return;               // a newer write took over
      if (k >= LETTERS.length) { cur.r = OUT; paint(); if (done) done(); return; }
      var L = LETTERS[k]; cur.r = L[0] - 0.6; paint();
      tween({ l: IN, r: (k === LETTERS.length - 1 ? OUT : L[1] + 0.6), d: 0 }, LETTER_MS, easeStroke, function () { k++; setTimeout(next, k < LETTERS.length ? LETTER_GAP : 0); });
    })();
  }
  // play(fromBlank): fromBlank = the logo was off screen just before (the sticky bar is sliding back in), so
  // skip the cut-out and simply write the word in — no "on, off, write" flash. Otherwise cut out, then write in.
  var pending = false, snap = '';
  function now() { return state + '|' + filled; }
  function play(fromBlank) {
    if (busy) { pending = true; return; }
    busy = true; gen++; snap = now();
    var done = function () { busy = false; if (pending) { pending = false; if (now() !== snap) play(false); } };   // re-run only for a real later change
    if (fromBlank) { writeIn(0, done); return; }
    tween({ l: OUT, r: OUT, d: DRIFT }, OUT_MS, easeOut, function () { setTimeout(function () { writeIn(0, done); }, GAP_MS); });
  }

  var mark = null;
  function logoOnScreen() {
    if (!mark || !mark.isConnected) mark = document.querySelector('.header__logo');
    if (!mark) return false;
    var b = mark.getBoundingClientRect(); return b.bottom > 0 && b.top < window.innerHeight;
  }
  function y() { var v = window.pageYOffset || 0; return v < 0 ? 0 : v; }

  // State = "top" or "scrolled" plus the header's own filled class. Both usually flip ~100ms apart, so
  // changes are merged for 150ms and played once. Changes while the logo is off screen are remembered.
  var header = null, state = null, filled = null, ticking = false, owed = false, wasOff = false, actT = 0;
  function readState() { return y() <= THRESH ? 'top' : 'scrolled'; }
  function update() {
    ticking = false;
    if (!header || !header.isConnected) header = document.querySelector('.header');
    var s = readState(), f = header ? header.classList.contains('is-filled') : false, on = logoOnScreen();
    if (!on) wasOff = true;
    if (state === null) { state = s; filled = f; return; }
    if (s !== state || f !== filled) { state = s; filled = f; owed = true; if (!actT) actT = setTimeout(act, 150); }
    else if (on && !owed) wasOff = false;
  }
  function act() {
    actT = 0;
    if (!owed) return;
    if (logoOnScreen()) { owed = false; var fb = wasOff; wasOff = false; play(fb); }
    else watchOwed();
  }
  var watching = false;
  function watchOwed() {                    // the sticky bar can slide in after the scroll stops: look again for ~0.8s
    if (watching) return; watching = true;
    var t0 = 0;
    (function look(t) {
      if (!t0) t0 = t;
      if (!owed) { watching = false; return; }
      if (logoOnScreen()) { owed = false; watching = false; wasOff = false; play(true); return; }
      if (t - t0 < 800) requestAnimationFrame(look); else watching = false;
    })(performance.now());
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

  var on = false, mo = null;
  function enable() {
    if (on) return; on = true;
    window.addEventListener('scroll', onScroll, { passive: true });
    header = document.querySelector('.header');
    if (header && window.MutationObserver) { mo = new MutationObserver(onScroll); mo.observe(header, { attributes: true, attributeFilter: ['class'] }); }
    update();
    var first = false;
    try { first = !sessionStorage.getItem('vlnLogoWritten'); sessionStorage.setItem('vlnLogoWritten', '1'); } catch (e) {}
    var stillHidden = document.documentElement.classList.contains('vln-logo-intro');   // false if the 4s failsafe already showed it (slow network): never hide a visible logo
    if (first && stillHidden && logoOnScreen()) writeIn();   // first page of the visit: the word writes itself in
    else document.documentElement.classList.remove('vln-logo-intro');
  }
  function disable() {
    if (!on) return; on = false;
    window.removeEventListener('scroll', onScroll); if (mo) { mo.disconnect(); mo = null; }
    if (raf) { cancelAnimationFrame(raf); raf = 0; }
    cur.l = IN; cur.r = OUT; cur.d = 0; busy = false; paint();
    document.documentElement.classList.remove('vln-logo-intro');
  }
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function sync() { if (mq && mq.matches) disable(); else enable(); }
  if (mq) { if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  document.addEventListener('shopify:section:load', function () { imgs = null; mark = null; header = null; paint(); });
})();
